<template>
  <listado-noticias
    endpoint="/noticiasCaritas/todasNoticiasVisibles"
    title="Cáritas parroquial"
    eyebrow="Noticias"
    subtitle="Actividades, campañas y proyectos de Cáritas en la parroquia."
    caritas
  />
</template>

<script>
import listadoNoticias from "@/components/website/ListadoNoticias.vue";

export default {
  name: "vistaNoticiasCaritas",
  components: {
    listadoNoticias,
  },
  metaInfo() {
    return {
      title: `${this.$root.constantes.nombre_sitio} - Cáritas parroquial`,
      meta: [
        {
          name: "description",
          content: `Noticias de Cáritas de la ${this.$root.constantes.nombre_sitio}`,
        },
      ],
      link: [
        {
          rel: "canonical",
          href: `${this.$root.constantes.sitio_web}${this.$route.fullPath}`,
        },
      ],
    };
  },
};
</script>
